import React from 'react'

import PropTypes from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import Icon from './Icon/Icon'
import Tooltip from './Tooltip'

const DEFAULT_AVAILABILITY_NOTIFICATION = {
  message: null,
  type: 'notification',
}

function InputField({
  label = '',
  id,
  value = '',
  name = '',
  onChange,
  onBlur = NOOP,
  showError = false,
  errorText = null,
  type = 'text',
  autofocus = false,
  moreInfo = '',
  required = false,
  disabled = false,
  formClassName = '',
  inputClassName = '',
  placeholder = '',
  availabilityNotification = DEFAULT_AVAILABILITY_NOTIFICATION,
}) {
  const inputErrorClass = showError && errorText ? 'is-invalid' : ''

  const inputNotificationClass = () => {
    if (showError && errorText) {
      return 'is-invalid'
    } if (availabilityNotification.message && availabilityNotification.type === 'notification') {
      return 'with-notification'
    } if (availabilityNotification.message && availabilityNotification.type === 'error') {
      return 'is-invalid'
    }
    return ''
  }

  return (
    <div className={`form-group ${formClassName}`}>
      {label !== '' && (
        <label htmlFor={id}>
          {label}
          {required
            && <b> *</b>
          }
          {moreInfo !== ''
            && (
            <Tooltip
              tooltipClassName="tooltip--medium tooltip--spaced u-text-center"
              id="top-keywords--tooltip"
              content={moreInfo}
            >
              <Icon type={['fas', 'question-circle']} color="grey" className="info-icon ml-5" />
            </Tooltip>
            )
          }
        </label>
      )}

      <input
        className={`form-control ${inputClassName} ${inputErrorClass} ${inputNotificationClass()}`}
        id={id}
        type={type}
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        autoFocus={autofocus}
        placeholder={placeholder}
      />
      {showError
        && (
        <div className="error-message">
          <span className="text">{errorText}</span>
        </div>
        )
      }
      {availabilityNotification.message && !errorText
        && (
        <div
          className={availabilityNotification.type === 'notification' ? 'notification-message' : 'error-message'}
        >
          <span className="text">{availabilityNotification.message}</span>
        </div>
        )
      }
    </div>
  )
}

InputField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  showError: PropTypes.bool,
  errorText: PropTypes.string,
  type: PropTypes.string,
  autofocus: PropTypes.bool,
  moreInfo: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  formClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  availabilityNotification: PropTypes.object,
}

export default InputField
